<template>
  <div class="modal" data-backdrop="static" id="bsInvoiceSaveFormDialog" ref="bsInvoiceSaveFormDialog">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content viewDetails">
        <form name="saveInvoice"
              :action="pUrls['saveInvoice']"
              method="post" class="ajax-support show-waiting dropdown-menu-position-inline"
              data-ajax-support-csv="#ajaxModuleForm"
              data-ajax-legacy="true">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span>
            </button>
            <h3 class="modal-title">{{ title }}</h3>
          </div>
          <div class="modal-body max-height fileupload-dropzone bs3-padding-top-reset bs3-padding-bottom-reset overflow-y-hidden"
               style="overflow-y: hidden;">

            <input type="hidden" name="dataForm.data.id" :value="data.id"/>

            <input type="hidden" name="src" :value="pSrc"/>
            <input type="hidden" name="srcId" :value="pSrcId"/>

            <div v-if="linkedMediaInsertionCreateMsgVisible" class="bs3-padding text-center bs3-margin-left-minus15 bs3-margin-right-minus15 bg-success">
              <div class="text-success"><i class="fa-light fa-layer-group"></i> <span v-html="linkedMediaInsertionCreateMsg"></span> <button v-if="linkedMediaInsertionUnlinkButtonVisible" @click.prevent="unlink" class="btn btn-default btn-sm bs3-margin-left"><span class="fa-stack fa-2x"><i class="fa-light fa-layer-group fa-stack-2x"></i><i class="fa-light fa-slash fa-stack-2x"></i></span> {{ 'dictionary.actions.unlink' | i18nText(pDictionary) }}</button></div>
            </div>
            <div v-else-if="linkedMediaInsertionUpdateMsgVisible" class="bs3-padding text-center bs3-margin-left-minus15 bs3-margin-right-minus15 bg-success">
              <div class="text-success"><i class="fa-light fa-layer-group"></i> <span v-html="linkedMediaInsertionUpdateMsg"></span> <button v-if="linkedMediaInsertionUnlinkButtonVisible" @click.prevent="unlink" class="btn btn-default btn-sm bs3-margin-left"><span class="fa-stack fa-2x"><i class="fa-light fa-layer-group fa-stack-2x"></i><i class="fa-light fa-slash fa-stack-2x"></i></span> {{ 'dictionary.actions.unlink' | i18nText(pDictionary) }}</button></div>
            </div>

            <div v-if="nbOfErrors > 0">
              <div class="bs3-padding text-center bs3-margin-left-minus15 bs3-margin-right-minus15 bg-danger">
                <span class="label label-danger">{{ nbOfErrors | error(pDictionary) }}</span>
              </div>
            </div>

            <div class="row scrollable-content scroll-y-xs noscroll-y-lg">
              <div class="col-md-12 col-lg-2 col-separator-right bs3-padding full-height-lg noscroll-y-xs scroll-y-lg">
                <invoice-save-form-media-insertion-section
                    :p-currencies="pCurrencies"
                    :p-language="pLanguage"
                  :p-dictionary="pDictionary"
                  :p-urls="pUrls"
                  :p-error-list="pErrorList"
                  :p-src="pSrc"
                  :p-src-id="pSrcId"
                  :p-invoice="data"
                  @invoice-mediaplan-updated="onInvoiceMediaPlanUpdated"
                  @invoice-campaign-updated="onInvoiceCampaignUpdated"
                  @invoice-organizations-updated="onInvoiceOrganizationsUpdated">
                </invoice-save-form-media-insertion-section>
              </div>
              <div class="col-md-12 col-lg-7 col-separator bs3-padding full-height-lg noscroll-y-xs scroll-y-lg">
                <invoice-save-form-invoice-section
                    :p-currencies="pCurrencies"
                    :p-language="pLanguage"
                    :p-dictionary="pDictionary"
                    :p-urls="pUrls"
                    :p-error-list="pErrorList"
                    :p-src="pSrc"
                    :p-src-id="pSrcId"
                    :p-invoice.sync="data"
                    :p-tax-enabled="data.taxEnabled"
                    :p-commission-enabled="data.commissionEnabled"
                    :p-validate-payment-deadline-date-enabled="pDataForm.validatePaymentDeadlineDateEnabled"
                    :p-all-statuses="allStatuses"
                    :p-all-taxes="allTaxes"
                    @invoice-media-updated="onInvoiceMediaUpdated"
                    @invoice-media-format-updated="onInvoiceMediaFormatUpdated"
                    @invoice-updated="onInvoiceUpdated"
                    @invoice-add-tax="onInvoiceAddTax"
                    @invoice-distribute-cost-organization="onInvoiceDistributeCostOrganization"
                    @invoice-remove-tax="onInvoiceRemoveTax"></invoice-save-form-invoice-section>
              </div>
              <div class="col-md-12 col-lg-3 col-separator-left bs3-padding full-height-lg noscroll-y-xs scroll-y-lg">
                <!--
                  - STATUS
                  --->
                <div :class="['form-group', {'has-error': hasFieldErrors('dataForm.data.statusRef')}]">
                  <div v-if="hasFieldErrors('dataForm.data.statusRef')">
                    <span v-for="error in getFieldErrors('dataForm.data.statusRef')" class="help-block" :key="error">{{ error }}</span>
                  </div>
                  <label v-else :for="'invoice_Status'">
                    <span class="required">*</span> {{ pDictionary['dictionary.invoice.status.short'] }}:
                  </label>
                  <select ref="statusSelect"
                          :id="'invoice_Status'"
                          :name="'dataForm.data.statusRef.id'"
                          v-model="statusRefId"
                          data-container="#bsInvoiceSaveFormDialog"
                          class="form-control selectpicker">
                    <option v-for="status in allStatuses"
                            :value="status.id"
                            :data-tokens="pLanguage === 'fr' ? status.names.fr : status.name" :key="status.id">
                      {{ i18nRefName(status, pLanguage) }}
                    </option>
                  </select>
                </div>

                <!--
                - NOTES
                -->
                <fieldset class="bs3-margin-top30">
                  <legend><i class="fa-light fa-sticky-note" aria-hidden="true"></i> {{ 'dictionary.media.insertion.notes' | i18nText(pDictionary) }}</legend>
                  <div>
                    <div class="form-group">
                      <textarea name="dataForm.data.notes" class="form-control" rows="5" v-model="data.notes"></textarea>
                    </div>
                  </div>
                </fieldset>

                <!--
                 - ADDITIONAL INFO
                 -->
                <field-value-list-form-section
                    :p-currencies="pCurrencies"
                    :p-language="pLanguage"
                    :p-dictionary="pDictionary"
                    :p-urls="pUrls"
                    :p-error-list="pErrorList"
                    :p-src="pSrc"
                    :p-src-id="pSrcId"
                    :p-field-value-list="data.fieldValueRefs">
                </field-value-list-form-section>

              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="text-right">
              <button type="submit" class="btn btn-primary" :disabled="saveButtonDisabled">
                <i class="fa-light fa-check"></i> <span>{{ pDictionary['dictionary.actions.save'] }}</span>
              </button>
              <a href="#"
                 class="btn btn-link" data-dismiss="modal" aria-label="Cancel">{{ pDictionary['dictionary.actions.cancel'] }}</a>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import stringhelpers from "@/helpers/string-helpers"
import InvoiceSaveFormInvoiceSection from "@/components/modules/accounting-module/invoice/form/save/InvoiceSaveFormInvoiceSection";
import InvoiceSaveFormMediaInsertionSection from "@/components/modules/accounting-module/invoice/form/save/InvoiceSaveFormMediaInsertionSection";
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";
import refHelpers from "@/helpers/ref-helpers";
import FieldValueListFormSection from "@/components/common/field/form/FieldValueListFormSection";

export default {
  name: "InvoiceSaveForm",
  mixins: [BaseMixin, FormMixin, FormatMixin],
  components: {
    InvoiceSaveFormMediaInsertionSection,
    InvoiceSaveFormInvoiceSection,
    FieldValueListFormSection
  },
  props: {
    pDataForm: Object
  },
  data: function () {
    return {
      data: this.pDataForm.data,
      saveButtonDisabled: false,
      allStatuses: [],
      allTaxes: [],
      allPaymentTypes: [ 'CASH',
        'CHECK',
        'CREDIT_CARD',
        'BANK_TRANSFER',
        'ONLINE_PAYMENT',
        'MOBILE_PAYMENT',
        'AUTOMATIC_PAYMENT',
        'OTHER']
    }
  },
  methods: {
    invoiceKey: function (invoice, index) {
      return invoice.id > 0 ? invoice.id : -index;
    },
    onInvoiceUpdated: function (invoice, initiatedByField, fieldRefId) {
      this.refreshInvoice(invoice, initiatedByField, fieldRefId);
    },
    onInvoiceMediaPlanUpdated: function(mediaPlanId) {
      this.data.projectRef = refHelpers.isValidRefId(mediaPlanId) ? {id: mediaPlanId} : null;
      this.refreshInvoice(this.data, 'MEDIA_PLAN');
    },
    onInvoiceCampaignUpdated: function(campaignId) {
      this.data.campaignRef = refHelpers.isValidRefId(campaignId) ? {id: campaignId} : null;
      this.refreshInvoice(this.data, 'CAMPAIGN');
    },
    onInvoiceOrganizationsUpdated: function(organizationIds) {
      this.updateOrganizations(organizationIds);
    },
    onInvoiceMediaUpdated: function(mediaId) {
      this.data.mediaRef = refHelpers.isValidRefId(mediaId) ? {id: mediaId} : null;
    },
    onInvoiceMediaFormatUpdated: function(mediaFormatId) {
      this.data.mediaFormatRef = refHelpers.isValidRefId(mediaFormatId) ? {id: mediaFormatId} : null;
    },
    onInvoiceAddTax: function (invoice, taxId) {
      this.addTax(invoice, taxId);
    },
    onInvoiceDistributeCostOrganization: function (invoice) {
      this.distributeCostOrganization(invoice);
    },
    onInvoiceRemoveTax: function (invoice, taxIndex) {
      this.removeTax(invoice, taxIndex);
    },
    updateOrganizations: function(organizationIds) {
      let _component = this;
      return $.ajax({
                      type: "POST",
                      url: "/mediaplan/app/endpoints/json-api/invoices/form/update-organizations?organizationIds=" + organizationIds,
                      data: JSON.stringify(_component.data),
                      headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                      }
                    }).done(function (updatedData) {
        _component.data = updatedData;
      });
    },
    refreshInvoice: function (invoice, initiatedByField, initiatedByFieldId) {
      let _component = this;
      _component.saveButtonDisabled = true;
      return $.ajax({
                      type: "POST",
                      url: "/mediaplan/app/endpoints/json-api/invoices/form/refresh?initiatedByField=" + initiatedByField + "&initiatedByFieldId=" + (initiatedByFieldId || ''),
                      data: JSON.stringify(invoice),
                      headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                      }
                    }).done(function (updatedData) {
        _component.data = updatedData;
         _component.saveButtonDisabled = false;
      });
    },
    addTax: function (invoice, taxId) {
      let _component = this;
      return $.ajax({
                      type: "POST",
                      url: "/mediaplan/app/endpoints/json-api/invoices/form/add-tax?taxId=" + taxId,
                      data: JSON.stringify(invoice),
                      headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                      }
                    }).done(function (updatedData) {
        _component.data = updatedData;
      });
    },
    distributeCostOrganization: function (invoice, taxId) {
      let _component = this;
      return $.ajax({
                      type: "POST",
                      url: "/mediaplan/app/endpoints/json-api/invoices/form/distribute-cost-organization",
                      data: JSON.stringify(invoice),
                      headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                      }
                    }).done(function (updatedData) {
        _component.data = updatedData;
      });
    },
    removeTax: function (invoice, taxIndex) {
      this.data.actualTaxCostList.splice(taxIndex, 1);
      this.refreshInvoice(invoice, "TAX_COST");
    },
    isIdValid: function () {
      return this.data.id !== undefined
             && this.data.id > 0;
    },
    hasStatus: function () {
      return !$.isEmptyObject(this.data.statusRef)
             && 'id' in this.data.statusRef
             && this.data.statusRef.id !== undefined
             && this.data.statusRef.id > 0;
    },
    refreshInvoiceStatuses: function() {
      // TODO: VueX
      let _component = this;
      $.ajax({
               type: "GET",
               url: "/mediaplan/app/endpoints/json-api/invoice-statuses/ref",
               data: {},
               headers: {
                 'Accept': 'application/json',
                 'Content-Type': 'application/json'
               }
             }).done(function (data) {
        $.each(data, function (index, value) {
          _component.allStatuses.push(value);
        });
      });
    },
    refreshTaxes: function() {
      // TODO: VueX
      let _component = this;
      $.ajax({
               type: "GET",
               url: "/mediaplan/app/endpoints/json-api/taxes/ref",
               data: {},
               headers: {
                 'Accept': 'application/json',
                 'Content-Type': 'application/json'
               }
             }).done(function (data) {
        $.each(data, function (index, value) {
          _component.allTaxes.push(value);
        });
      });
    },
    hasMediaInsertion: function() {
      return refHelpers.isValidRef(this.data.mediaInsertionRef)
    },
    unlink: function() {
      if(!this.isIdValid() && !this.data.expected) {
        this.data.mediaInsertionRef = null;
      }
    }
  },
  computed: {
    title: function () {
      return this.isIdValid()
             ? this.pDictionary['dictionary.invoice.list.udate.title']
             : this.pDictionary['dictionary.invoice.list.create.title'];
    },
    linkedMediaInsertionNbOfInvoices: function() {
      if(refHelpers.isValidRef(this.data.mediaInsertionRef)) {
        return this.data.mediaInsertionRef.params.nbOfInvoices;
      }
      return 0;
    },
    linkedMediaInsertionCreateMsgVisible: function() {
      return !this.isIdValid() && refHelpers.isValidRef(this.data.mediaInsertionRef);
    },
    linkedMediaInsertionCreateMsg: function() {
      let msg = stringhelpers.formatI18nText('dictionary.invoice.linked.to.media.insertion.create.message', this.pDictionary);
      msg = stringhelpers.formatI18nParams(msg, 0, this.linkedMediaInsertionInvoiceListInfoUrl);
      msg = stringhelpers.formatI18nParams(msg, 1, this.linkedMediaInsertionNbOfInvoices);
      return msg;
    },
    linkedMediaInsertionUpdateMsgVisible: function() {
      return this.isIdValid() && refHelpers.isValidRef(this.data.mediaInsertionRef) && this.data.mediaInsertionRef.params.nbOfInvoices > 1;
    },
    linkedMediaInsertionUpdateMsg: function() {
      let msg = stringhelpers.formatI18nText('dictionary.invoice.linked.to.media.insertion.update.message', this.pDictionary);
      msg = stringhelpers.formatI18nParams(msg, 0, this.linkedMediaInsertionInvoiceListInfoUrl);
      msg = stringhelpers.formatI18nParams(msg, 1, this.linkedMediaInsertionNbOfInvoices);
      return msg;
    },
    linkedMediaInsertionUnlinkButtonVisible: function() {
      return !this.isIdValid() && !this.data.expected;
    },
    linkedMediaInsertionInvoiceListInfoUrl: function() {
      if(refHelpers.isValidRef(this.data.mediaInsertionRef)) {
        return this.pUrls['showInvoiceListInfo'] + "?reset=true&dataId=" + this.data.mediaInsertionRef.id + "&ajax=true&formDisplay=true";
      }
      return null;
    },
    statusRefId: {
      get: function () {
        return this.hasStatus() ? this.data.statusRef.id : '';
      },
      set: function (rateTypeRefId) {
        this.data.statusRef = this.allStatuses.find(obj => {
          return obj.id === rateTypeRefId
        }) || this.allStatuses[0];
      }
    }
  },
  filters: {
    safeReference: function (reference, dictionary, index) {
      if(!reference)
      {
        return dictionary['dictionary.invoice'] + index;
      }
      return reference;
    }
  },
  mounted: function () {
    let _component = this;

    _component.refreshInvoiceStatuses();
    _component.refreshTaxes();

     let $bsInvoiceSaveFormDialog = $(this.$refs.bsInvoiceSaveFormDialog);
     $bsInvoiceSaveFormDialog.on('shown.bs.modal', function () {
        // Destroy the tooltips.
        $bsInvoiceSaveFormDialog.find('[data-toggle="tooltip"]').tooltip();

        // Init BootstrapSelect
        let $statusSelect = $(_component.$refs.statusSelect);
        $statusSelect.selectpicker();

        console.log("adaptLayout");
        $().adaptLayout();
     });

     $bsInvoiceSaveFormDialog.on('hidden.bs.modal', function () {
        // Destroy the tooltips.
        $bsInvoiceSaveFormDialog.find('[data-toggle="tooltip"]').tooltip('destroy');

        // Destroy BootstrapSelect
        let $statusSelect = $(_component.$refs.statusSelect);
        $statusSelect.selectpicker('destroy');
     });

    $(this.$refs.bsInvoiceSaveFormDialog).modal();
  },
  updated: function () {
    let _component = this;

    // Sync BootstrapSelect
    let $statusSelect = $(_component.$refs.statusSelect);
    $statusSelect.selectpicker('refresh');
  }
}
</script>

<style scoped>

</style>